import {Icons} from '~/common/Icon';
import {PlateType} from '~/common/display/Plate/Plate';
import {NotificationActionType, NotificationType} from '~/services/hot-api/notifications';

import ActionButton from './parts/ActionButton/ActionButton';
import ActionPromo from './parts/ActionPromo/ActionPromo';

export const NotificationToPlateMap = {
  [NotificationType.error]: {
    icon: Icons.infoCircleNew,
    plateType: PlateType.error,
  },
  [NotificationType.info]: {
    icon: Icons.infoCircleNew,
    plateType: PlateType.info,
  },
  [NotificationType.success]: {
    icon: Icons.infoCircleNew,
    plateType: PlateType.success,
  },
};

export const ActionsMap = {
  [NotificationActionType.Button]: ActionButton,
  [NotificationActionType.AllPromoControl]: ActionPromo,
};
